import React from 'react';

function Design() {
	return (
		<section id="design">
			<h2>Design Tools</h2>
			<ul id="design_tools">
				<li>
					<h3>Adobe Photoshop</h3>
					<span className="notes">mainly for UI design</span>
				</li>
				<li>
					<h3>Adobe Illustrator</h3>
					<span className="notes">for designing basic icons</span>
				</li>
			</ul>
		</section>
	);
}

export default Design;
